import { ThemeProvider } from '@change/ds-core-ui';

import { createModalHook } from '@change-corgi/design-system-legacy/modals';

import { EducationModal } from './components/EducationModal';
import { EducationModalHeading } from './components/EducationModalHeading';

export type UseStoriesEducationModalProps = {
	onContinueAction: () => Promise<void>;
	shareVisualPreview: File | string | null;
};

export const useStoriesEducationModal = createModalHook<UseStoriesEducationModalProps, { successfulShare: boolean }>({
	name: 'InstagramStoriesShareEducationModal',
	heading: function EducationModalHead() {
		return (
			<ThemeProvider>
				<EducationModalHeading />
			</ThemeProvider>
		);
	},
	body: function EducationModalBody({ closeModal, options: { onContinueAction, shareVisualPreview } }) {
		return (
			<ThemeProvider>
				<EducationModal
					onContinue={async () => {
						await onContinueAction();
						closeModal({ successfulShare: true });
					}}
					shareVisualPreview={shareVisualPreview}
				/>
			</ThemeProvider>
		);
	},
	// oxlint-disable-next-line typescript/no-unsafe-assignment, typescript/no-unsafe-type-assertion
	stylesOverrides: {
		width: '100vw',
		position: 'fixed',
		bottom: 0,
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
		'& [data-qa="modal-close-button"]': {
			width: 24,
			height: 24,
			top: 12,
			'& svg': {
				width: 24,
				height: 24,
			},
		},
		// oxlint-disable-next-line typescript/no-explicit-any
	} as any,
	// if share attempt is done within another modal, we need to kill that modal
	// to avoid multiple layers of modals
	killOpenModal: true,
});
